import { Controller } from '@hotwired/stimulus';

// Stimulus controller for Turbo-driven forms.
// - locks all input and submit targets while turbo frame is submitting
export default class extends Controller {
  static targets = ['input', 'submit'];

  connect() {
    this.element.addEventListener('turbo:submit-start', this.#lock);
    this.element.addEventListener('turbo:submit-end', this.#unlock);
    requestAnimationFrame(() => this.inputTargets[0]?.focus());
  }

  disconnect() {
    this.element.removeEventListener('turbo:submit-start', this.#lock);
    this.element.removeEventListener('turbo:submit-end', this.#unlock);
  }

  // --- Private ---

  #lock = () => {
    this.#disable(this.submitTarget);
    this.inputTargets.forEach((input) => this.#disable(input));
  };

  #unlock = () => {
    this.#enable(this.submitTarget);
    this.inputTargets.forEach((input) => this.#enable(input));
  };

  #disable(el) {
    el.disabled = true;
    el.classList.add('opacity-50', 'cursor-not-allowed');
  }

  #enable(el) {
    el.disabled = false;
    el.classList.remove('opacity-50', 'cursor-not-allowed');
  }
}
